<template>
    <div class="create-order-warp">
        <div class="create-order-type-box">
            <div class="order-selfgo" v-if="orderType == '2'">
                <div class="shop-name"><span>壹灵雯杭州大厦501店</span> <Icon name="arrow" /></div>
                <div class="shop-address">上城区-景昙路9号-杭州大厦501城市广场一层</div>
            </div>
            <div class="order-send" v-else>
                <div class="send-address" @click="goAddressPage"><span>{{ addressObj.address }}</span><Icon name="arrow" /></div>
                <div class="send-info">{{ addressObj.name }} {{ addressObj.phone_number }}</div>
            </div>
            <div class="order-switch" @click="changeType">
                <div :class="[orderType == '2' ? 'active' : '']">自提</div>
                <div :class="[orderType == '1' ? 'active' : '']">快递</div>
            </div>
        </div>
        <div class="create-order-goods-box">
            <div class="order-msg">
                <div class="order-pic">
                    <img :src="goodItem.cover_image" />
                </div>
                <div class="order-info">
                    <div class="order-name">{{ goodItem.goods_name }}</div>
                    <div class="order-desc">{{ goodItem.desc }}</div>
                    <div class="order-old-price"><span>¥</span>{{ goodItem.price / 100 }}</div>
                </div>
            </div>
        </div>
        <div class="order-coupons">
            <div class="order-coupons-check-cell" @click="goCouponsList">
                <label>优惠券</label>
                <span v-if="ckeckObj.id">-¥{{ ckeckObj.discount_amount / 100 }}<Icon name="arrow-down" /></span>
                <span v-else>暂无可用优惠券</span>
            </div>
            <div class="order-coupons-current-amt" v-if="ckeckObj.id">
                <label>应付</label>
                <span>¥{{ (goodItem.price / 100 - ckeckObj.discount_amount / 100).toFixed(2) }}</span>
            </div>
        </div>
        <Cell title="支付方式" value="微信支付" />
        <!--<Cell title="运费" value="6元" v-if="orderType == '1'"/>-->
        <div class="pay-button-box">
            <div class="pay-off-calc">
                <div class="all-cash">
                    <label>合计金额</label>
                    <span v-if="ckeckObj.discount_amount">¥{{ ((goodItem.price / 100) - (ckeckObj.discount_amount / 100)).toFixed(2) }}</span>
                    <span v-else>¥{{ goodItem.price / 100 }}</span>
                </div>
                <div class="all-cash-off" v-if="ckeckObj.discount_amount">
                    <label>共减</label>
                    <span>¥{{ ckeckObj.discount_amount / 100 }}</span>
                </div>
            </div>
            <div class="pay-button" @click="goPay">立即支付</div>
        </div>
        <Loading v-if="isLoading"/>
    </div>
</template>
<script>
import { Icon, Cell, Dialog } from 'vant';
import { getCouponsList, goodsDetail, createOrders, createPay, paySignInfo, wxSignInfo } from '../api/index.js'
import wx from 'weixin-js-sdk'
import Loading from '../components/loaddingCom'
export default {
    components: { Icon, Cell, Loading },
    data() {
        return {
            orderType: '2',
            couponsList: [],
            amt: 500,
            ckeckObj: {},
            selfgo: false,
            addressObj: {},
            goodItem: {},
            backType: true,
            isLoading: false
        }
    },
    activated() {
        this.getDetail(this.$route.query.goodsId)
        this.$EventBus.$on('couponsCheck', (data) => {
            console.log('couponsCheck=====>', data, this.couponsList)
            this.couponsList.forEach(element => {
                element.isChecked = false
            });
            this.couponsList[data.ckeckId].isChecked = true
            this.ckeckObj = this.couponsList[data.ckeckId]
        })
        this.$EventBus.$on('selectedAddress', (data) => {
            this.orderType = '1'
            this.addressObj = data
            console.log('addressObj=====>', this.addressObj)
        })
    },
    mounted() {
    },
    watch:{
        $route(to, from){
            console.log('route=======>', to, from)
            if (from.path == '/couponsList') {
                this.backType = false
            } else {
                this.backType = true
            }
        }
    },
    methods: {
        goCouponsList() {
            window.localStorage.setItem('couponsList', JSON.stringify(this.couponsList))
            this.$router.push({path:'/couponsList',query:{amt: this.goodItem.price}})
        },
        getDetail(e){
            if(!this.backType) {
                return
            }
            goodsDetail({goods_id: e}).then(res => {
                console.log(res)
                if(res.message == 'success') {
                    this.goodItem = res.data
                    this.getcouponsList()
                }
            })
        },
        getcouponsList() {
            let data = {
                page: 1,
                page_size: 100,
                use_flag: 1,
                expire_flag: 1
            }
            getCouponsList(data).then(res => {
                console.log('getcouponsList=======>', res)
                if (res.message == 'success') {
                    let list = res.data.data || []
                    if (list.length) {
                        let canUseList = []
                        let cannotUseList = []
                        list.map(element => {
                            console.log('element====>', element)
                            if (element.target_amount < this.goodItem.price || element.target_amount == this.goodItem.price) {
                                element.canUse = true
                                canUseList.push(element)
                            } else {
                                element.canUse = false
                                cannotUseList.push(element)
                            }
                        });
                        canUseList.sort((a, b) => {
                            return b.discount_amount - a.discount_amount
                        })
                        console.log('canUseList====>', canUseList)
                        if (canUseList.length) {
                            canUseList[0].isChecked = true
                            this.ckeckObj = canUseList[0]
                        } else {
                            this.ckeckObj = {}
                        }
                        this.couponsList = [ ...canUseList, ...cannotUseList]
                        console.log('canUseList====>', this.couponsList)
                    }
                }
            })
        },
        goPay() {
            Dialog.confirm({
                title: '确定购买',
                message: '是否确定要购买' + this.goodItem.goods_name + '？',
            })
            .then(() => {
                this.isLoading = true
                let orderData={
                    take_delivery_type: parseInt(this.orderType),
                    order_goods: [{
                        goods_id: this.goodItem.goods_id,
                        number: 1
                    }]
                }
                if (this.ckeckObj && this.ckeckObj.user_coupon_id) {
                    orderData.user_coupon_ids = [this.ckeckObj.user_coupon_id]
                }
                if (this.orderType == '1') {
                    orderData.order_address = {
                        phone_number: this.addressObj.tel,
                        name: this.addressObj.name,
                        province: this.addressObj.province,
                        city: this.addressObj.city,
                        district: this.addressObj.district,
                        address: this.addressObj.shortAddress
                    }
                }
                createOrders(orderData).then(res => {
                    this.isLoading = false
                    if(res.message == 'success') {
                        this.toPay(res.data.order_id)
                    }
                }).catch(() => {
                    this.isLoading = false
                })
            })
            .catch(() => {
                // on cancel
            });
        },
        toPay(e){
            createPay({order_id: e}).then(res => {
                if(res.message == 'success') {
                    wxSignInfo({url: 'https://shop.lscyyw.top/prdDetailPage'}).then(item => {
                        if(item.message == 'success') {
                            paySignInfo({prepay_id: res.data}).then(data => {
                                if(data.message == 'success') {
                                    this.weixinPay(data.data, item.data, e)
                                }
                            })
                        }
                    })
                }
            })
        },
        weixinPay(e, i, x){
            wx.config({
                debug: false, // 开启debug模式，输出日志信息
                appId: i.app_id, // 必填，公众号的唯一标识
                timestamp: i.timestamp, // 必填，生成签名的时间戳
                nonceStr: i.nonce_str, // 必填，生成签名的随机串
                signature: i.sign, // 必填，签名
                jsApiList: ['chooseWXPay'], // 必填，需要使用的JS接口列表
            });
            wx.ready(() => {
                console.log('微信JS-SDK初始化成功');
                wx.chooseWXPay({
                    appId: e.app_id, 
                    timestamp: e.timestamp,
                    nonceStr: e.nonce_str,
                    package: e.package,
                    signType: e.sign_type,
                    paySign: e.sign,
                    success: (res) => {
                        console.log('微信支付成功', res);
                        this.$router.push({path:'/successPage',query:{backUrl: '/orderList?orderStatus=2', order_id: x}})
                    },
                    fail: (err) => {
                    console.error('微信支付失败', err);
                    // TODO: 处理支付失败的逻辑
                    }
                });
            });

        },
        changeType() {
            if (this.orderType == '2') {
                this.orderType = '2'
                this.$router.push({path:'/addressList', query:{from: 'order'}})
            } else {
                this.orderType = '2'
            }
        },
        goAddressPage() {
            this.$router.push({path:'/addressList', query:{from: 'order'}})
        }
    },
    beforeDestroy() {
        this.$EventBus.$off('couponsCheck')
        this.$EventBus.$off('selectedAddress')
    },
}
</script>
<style lang="scss">
.create-order-warp {
    padding: 16px;
    background: #f9f9f9;
    .van-cell-group--inset {
        margin: 0;
    }
    .create-order-type-box {
        border-radius: 4px;
        background: #fff;
        margin-bottom: 16px;
        position: relative;
        padding: 16px;
        .order-selfgo {
            .shop-name {
                font-size: 14px;
                font-weight: 500;
                color: #000;
                line-height: 24px;
                display: flex;
                align-items: center;
                span {
                    display: inline-block;
                    max-width: 200px;
                    overflow: hidden;
                    white-space: nowrap;
                    text-overflow: ellipsis;
                }
            }
            .shop-address {
                font-size: 12px;
                font-weight: 400;
                line-height: 16px;
                color: #999
            }
        }
        .order-send {
            margin-bottom: 10px;
            .send-address {
                font-size: 14px;
                font-weight: 500;
                color: #000;
                line-height: 24px;
                display: flex;
                align-items: center;
                span {
                    display: inline-block;
                    max-width: 200px;
                    overflow: hidden;
                    white-space: nowrap;
                    text-overflow: ellipsis;
                }
            }
            .send-info {
                font-size: 12px;
                font-weight: 400;
                line-height: 16px;
                color: #999
            }
        }
        .order-switch {
            width: 80px;
            height: 24px;
            border-radius: 12px;
            background: #f9f9f9;
            position: absolute;
            top: 16px;
            right: 16px;
            display: flex;
            justify-content: center;
            align-items: center;
            overflow: hidden;
            > div {
                width: 40px;
                height: 18px;
                font-size: 12px;
                color: #999;
                text-align: center;
                line-height: 18px;
                border-radius: 12px;
                &.active {
                    color: #fff;
                    background: #08aef9;
                }
            }
        }
    }
    .create-order-goods-box {
        background: #fff;
        border-radius: 4px;
        padding: 16px;
        margin-bottom: 16px;
    }
    .order-coupons {
        margin-bottom: 16px;
        .order-coupons-check-cell {
            height: 44px;
            background: #fff;
            border-radius: 8px;
            padding: 10px 16px;
            display: flex;
            justify-content: space-between;
            align-items: center;
            box-sizing: border-box;
            > label {
                color: #323233;
                font-size: 14px;
                line-height: 24px;
            }
            > span {
                font-size: 16px;
                line-height: 24px;
                font-weight: 500;
                color: #f65a5a;
                > i {
                    color: #999;
                }
            }
        }
        .order-coupons-current-amt {
            background: #fff;
            border-radius: 8px;
            padding: 10px 16px;
            border-top: 1px dashed #ccc;
            text-align: right;
            height: 44px;
            box-sizing: border-box;
            display: flex;
            justify-content: flex-end;
            align-items: center;
            > label {
                font-size: 14px;
                font-weight: 400;
                color: #999;
                margin-right: 10px;
            }
            > span {
                font-size: 14px;
                font-weight: 500;
                color: #000;
            }
        }
    }
    .pay-button-box {
        height: 64px;
        padding: 0 16px;
        background: #fff;
        box-shadow: 0 4px 6px 0 rgba(211,211,211,0.50);
        position: fixed;
        bottom: 20px;
        left: 0;
        right: 0;
        display: flex;
        justify-content: space-between;
        align-items: center;
        .pay-off-calc {
            margin-right: 10px;
            .all-cash {
                font-size: 14px;
                > label {
                    color: #999;
                    font-weight: 400;
                    margin-right: 6px;
                }
                > span {
                    color: #f65a5a;
                    font-weight: 500;
                }
            }
            .all-cash-off {
                font-size: 14px;
                > label {
                    color: #999;
                    font-weight: 400;
                    margin-right: 6px;
                }
                > span {
                    color: #f65a5a;
                    font-weight: 500;
                }
            }
        }
        .pay-button {
            width: 100px;
            height: 40px;
            border-radius: 4px;
            background: #08aef9;
            color: #fff;
            font-size: 14px;
            font-weight: 500;
            text-align: center;
            line-height: 40px;
        }
    }
}
</style>

